var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-cards"},[_c('a-row',{attrs:{"gutter":[20, 20]}},_vm._l((_vm.countries),function(country){return _c('a-col',{key:country.cca2,attrs:{"xs":24,"sm":12,"md":8,"lg":6,"xl":6}},[_c('router-link',{attrs:{"to":{
          name: 'CountryDetail',
          params: { countryName: country.name.common },
        }}},[_c('CountryCard',{attrs:{"country":country}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }